import { myFetchRequestApi } from '@/http/my-fetch';
import { convertGlobalAoToLo, convertAirportsAoToLo, convertCarrierAoToLo } from '@/apis/home/model/index';
enum Api {
    contentService = 'contentService',
    orderService = 'orderService',
    getGlobalSetUrl = '/rest/polaris/globalset',
    getAirportsListUrl = '/rest/airport/search',
    getAirlineListUrl = '/PolarisOrder/airline/list'
}

// 获取热门城市接口列表
export const getGlobalSetApi2 = async (params: { lang: string; currency: string; }) => {
    const res = await myFetchRequestApi(
        Api.contentService,
        true,
        Api.getGlobalSetUrl,
        {
            method: 'GET',
            params
        });
    return convertGlobalAoToLo(res);
};

// 按关键字搜索城市接口
export const ApiGetAirportsList = async (params: { lang: string; keys: string; }) => {
    const res = await myFetchRequestApi(
        Api.contentService,
        false,
        Api.getAirportsListUrl,
        {
            method: 'GET',
            params
        });
    return convertAirportsAoToLo(res);
};

// 查询所有航司列表
export const ApiGetAirlineList = async () => {
    const res = await myFetchRequestApi(
        Api.orderService,
        true,
        Api.getAirlineListUrl,
        {
            method: 'GET',
            params: {},
        });
    return convertCarrierAoToLo(res);
};
